/* eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';
import { Descriptions, Table, Empty } from 'antd';
import QRCode from 'qrcode.react';
import './SelectedSaleInvoiceModal.scss';
import { useTranslation } from 'react-i18next';

const SaleInvoiceDetailsComponent = React.forwardRef((props, ref) => {
  const { selectedInvoice } = props;
  const { t, i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState();
  useEffect(() => {
    setCurrentLang(i18n.language);
  }, [i18n.language]);
  const renderDiscountValue = (record) => {
    if (record.discountType == '1') {
      // fixed discount price
      return record.discountPrice;
    } else if (record.discountType == '2') {
      // percentage discount
      return `${record.discountPrice}`;
    } else {
      // no discount
      return t('CashiersalesInvoiceReport.noDiscount');
    }
  };

  const renderClient = () => {
    const {
      user: { name, phone, email, address, user }
    } = selectedInvoice;
    return (
      <div className="supplier-details-wrap">
        <Descriptions
          title={t('CashiersalesInvoiceReport.client')}
          bordered
          column={1}
        >
          {name && (
            <Descriptions.Item label={t('CashiersalesInvoiceReport.name')}>
              {name}
            </Descriptions.Item>
          )}
          {phone && (
            <Descriptions.Item label={t('CashiersalesInvoiceReport.phone')}>
              {phone}
            </Descriptions.Item>
          )}
          {email && (
            <Descriptions.Item label={t('CashiersalesInvoiceReport.email')}>
              {email}
            </Descriptions.Item>
          )}
          {address && (
            <Descriptions.Item label={t('CashiersalesInvoiceReport.address')}>
              {address}
            </Descriptions.Item>
          )}
          {user?.commercialRecord && (
            <Descriptions.Item
              label={t('CashiersalesInvoiceReport.commercialRecord')}
            >
              {user?.commercialRecord}
            </Descriptions.Item>
          )}
        </Descriptions>
      </div>
    );
  };

  const renderModels = () => {
    const products = selectedInvoice.products;
    return (
      <div className="models-wrap">
        <div className="models-title bold-font">
          {t('CashiersalesInvoiceReport.description')}
        </div>
        <Table
          bordered
          locale={{
            emptyText: (
              <Empty description={false}>
                {t('CashiersalesInvoiceReport.noData')}
              </Empty>
            )
          }}
          pagination={{ defaultPageSize: 5, hideOnSinglePage: true }}
          // className="antd-custom-table"
          dataSource={products.map((item) => ({
            ...item,
            key: item.id
          }))}
          columns={[
            {
              title: t('CashiersalesInvoiceReport.code'),
              dataIndex: 'id',
              render: (_, record) => {
                return (
                  <div className="row-cell row-index bold-font">
                    <span>{record.id}</span>
                  </div>
                );
              }
            },
            {
              title: t('CashiersalesInvoiceReport.name'),
              dataIndex: 'name',
              render: (_, record) => {
                return (
                  <div className="row-cell row-text">
                    <span>{record.product?.name}</span>
                  </div>
                );
              }
            },
            {
              title: t('CashiersalesInvoiceReport.productQuantity'),
              dataIndex: 'quantity',
              render: (_, record) => {
                return (
                  <div className="row-cell row-text">
                    <span>
                      {String(record.quantity) ?<span>{selectedInvoice?.type == 2 && record.quantity > 0 && '-'}{record.quantity }</span>: '----'}
                    </span>
                  </div>
                );
              }
            },
            // {
            //   title: 'الكمية داخل المستودع',
            //   dataIndex: 'stock_quantity',
            //   render: (_, record) => {
            //     return (
            //       <div className="row-cell row-text">
            //         <span>
            //           {String(record.product?.quantityInPosStock)
            //             ? record.product.quantityInPosStock
            //             : '----'}
            //         </span>
            //       </div>
            //     );
            //   }
            // },
            {
              title: t('CashiersalesInvoiceReport.warehouse'),
              dataIndex: 'warehouse',
              render: (_, record) => {
                return (
                  <div className="row-cell row-text">
                    <span>
                      {record?.stock?.name ? record.stock.name : '----'}
                    </span>
                  </div>
                );
              }
            },
            {
              title: t('CashiersalesInvoiceReport.unitPrice'),
              dataIndex: 'price',
              render: (_, record) => {
                return (
                  <div className="row-cell row-text">
                    <span>{record.price}</span>
                  </div>
                );
              }
            },
            {
              title: t('CashiersalesInvoiceReport.beforeDiscount'),
              dataIndex: 'priceBeforeDiscount',
              render: (_, record) => {
                return (
                  <div className="row-cell row-text">
                    <span>{selectedInvoice?.type == 2 && record.priceBeforeDiscount > 0 && '-'}{record.priceBeforeDiscount}</span>
                  </div>
                );
              }
            },
            {
              title: t('CashiersalesInvoiceReport.discount'),
              dataIndex: 'discount',
              render: (_, record) => {
                return (
                  <div className="row-cell row-text">
                    <span>{renderDiscountValue(record)}</span>
                  </div>
                );
              }
            },
            {
              title: t('CashiersalesInvoiceReport.discountPrice'),
              dataIndex: 'discount',
              render: (_, record) => {
                return (
                  <div className="row-cell row-text">
                    <span>{selectedInvoice?.type == 2 && record.discountPrice > 0 && '-'}{record.discountPrice}</span>
                  </div>
                );
              }
            },
            {
              title: t('CashiersalesInvoiceReport.totalPrice'),
              dataIndex: 'discount',
              render: (_, record) => {
                return (
                  <div className="row-cell row-text">
                    <span>{selectedInvoice?.type == 2 && record.totalPrice > 0 && '-'}{record.totalPrice}</span>
                  </div>
                );
              }
            }
          ]}
          // loading={isLoading}
          // scroll={{ x: 400 }}
          footer={false}
        />
      </div>
    );
  };

  const renderExtraPrices = () => {
    const addPrices = selectedInvoice.addPrices;
    if (addPrices?.length > 0) {
      return (
        <div className="models-wrap">
          <div className="models-title bold-font">
            {t('CashiersalesInvoiceReport.extraPrices')}
          </div>
          <Table
            showHeader={false}
            bordered
            locale={{
              emptyText: (
                <Empty description={false}>
                  {t('CashiersalesInvoiceReport.noData')}
                </Empty>
              )
            }}
            pagination={{ defaultPageSize: 5, hideOnSinglePage: true }}
            // className="antd-custom-table"
            dataSource={addPrices.map((item) => ({
              ...item,
              key: item.id
            }))}
            columns={[
              // {
              //   title: 'الكود',
              //   dataIndex: 'id',
              //   render: (_, record) => {
              //     return (
              //       <div className="row-cell row-index bold-font">
              //         <span># {record.id}</span>
              //       </div>
              //     );
              //   }
              // },

              {
                title: t('CashiersalesInvoiceReport.desc'),
                dataIndex: 'desc',
                render: (_, record) => {
                  return (
                    <div className="row-cell row-text extra-prices-cell">
                      <span>{record.desc}</span>
                    </div>
                  );
                }
              },
              {
                title: t('CashiersalesInvoiceReport.price'),
                dataIndex: 'price',
                render: (_, record) => {
                  return (
                    <div className="row-cell row-text extra-prices-cell">
                      <span>{record.price}</span>
                    </div>
                  );
                }
              }
            ]}
            // loading={isLoading}
            // scroll={{ x: 400 }}
            footer={false}
          />
        </div>
      );
    }
    return null;
  };

  const renderInovicePrices = () => {
    const {
      productPrice,
      discountType,
      discountValue,
      discountPrice,
      additionPrice,
      totalBeforeTax,
      taxPrice,
      totalPrice,
      type
    } = selectedInvoice;
    return (
      <div className="supplier-details-wrap">
        <Descriptions
          title={t('CashiersalesInvoiceReport.totalAmounts')}
          bordered
          column={1}
        >
          {productPrice && (
            <Descriptions.Item
              label={t('CashiersalesInvoiceReport.totalAfterDiscount')}
            >
              {type == 2 && productPrice > 0 && '-'}
              {productPrice}
            </Descriptions.Item>
          )}
          {discountValue && (
            <Descriptions.Item label={t('CashiersalesInvoiceReport.discount')}>
              {renderDiscountValue({
                discountType,
                discountValue
              })}
            </Descriptions.Item>
          )}
          {discountPrice && (
            <Descriptions.Item
              label={t('CashiersalesInvoiceReport.discountPrice')}
            >
              {type == 2 && discountPrice > 0 && '-'}
              {discountPrice}
            </Descriptions.Item>
          )}
          {additionPrice && (
            <Descriptions.Item
              label={t('CashiersalesInvoiceReport.extraPrices')}
            >
              {type == 2 && additionPrice > 0 && '-'}
              {additionPrice}
            </Descriptions.Item>
          )}
          {totalBeforeTax && (
            <Descriptions.Item
              label={t('CashiersalesInvoiceReport.totalBeforeTax')}
            >
              {type == 2 && totalBeforeTax > 0 && '-'}
              {totalBeforeTax}
            </Descriptions.Item>
          )}
          {taxPrice && (
            <Descriptions.Item label={t('CashiersalesInvoiceReport.taxPrice')}>
              {type == 2 && taxPrice > 0 && '-'}
              {taxPrice}
            </Descriptions.Item>
          )}
          {totalPrice && (
            <Descriptions.Item
              label={t('CashiersalesInvoiceReport.totalWithTax')}
              style={{
                fontSize: '18px',
                color: '#000',
                fontWeight: 'bold'
              }}
            >
              {type == 2 && totalPrice > 0 && '-'}
              {totalPrice}
            </Descriptions.Item>
          )}
        </Descriptions>
      </div>
    );
  };

  return (
    <div
      className="invoice-details-wrap"
      ref={ref}
      style={{
        padding: 12
        // display: 'grid',
        // gap: '16px'
      }}
    >
      {/* <p
        style={{
          fontSize: 16,
          color: '#000',
          fontWeight: 'bold',
          textAlign: 'center',
          marginBottom: 6
        }}
      >
        {selectedInvoice?.setting?.ref_id}
      </p> */}
      <p
        style={{
          fontSize: 20,
          color: '#000',
          fontWeight: 'bold',
          textAlign: 'center',
          marginBottom: 12
        }}
      >
        <span>
          {selectedInvoice?.type == 1
            ? t('CashiersalesInvoiceReport.simplifiedTaxInvoice')
            : t('CashiersalesInvoiceReport.returnInvoice')}
        </span>
        {/* <span> - {selectedReceipt?.setting?.id}</span> */}
      </p>

      <div
        className="inovice-nums-qrcode"
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr auto',
          gap: '22px',
          alignItems: 'center',
          direction: currentLang == 'ar' ? 'rtl' : 'ltr'
        }}
      >
        <Descriptions title="" bordered column={1}>
          {selectedInvoice?.manualNum && (
            <Descriptions.Item
              label={t('CashiersalesInvoiceReport.invoiceNumber')}
            >
              00{selectedInvoice?.manualNum}
            </Descriptions.Item>
          )}
          {selectedInvoice?.date && (
            <Descriptions.Item
              label={t('CashiersalesInvoiceReport.releaseDate')}
            >
              {/* {moment(selectedInvoice.date).format('DD-MM-YYYY')} */}
              {selectedInvoice.date}
            </Descriptions.Item>
          )}
          {selectedInvoice?.time && (
            <Descriptions.Item
              label={t('CashiersalesInvoiceReport.releaseTime')}
            >
              {selectedInvoice.time}
            </Descriptions.Item>
          )}
          {selectedInvoice?.dueDate && (
            <Descriptions.Item label={t('CashiersalesInvoiceReport.dueDate')}>
              {selectedInvoice.dueDate}
            </Descriptions.Item>
          )}
        </Descriptions>
        <div className="qr-code-wrap">
          {/* <img className="qr-code-img" src={qrcodeImg} alt="qrcode" /> */}
          <QRCode
            value={selectedInvoice?.qrString ? selectedInvoice.qrString : ''}
            width={92}
            height={92}
            renderAs="svg"
          />
          {/* <QRCode
            value={
              selectedInvoice?.encryptId
                ? `${
                    process.env.REACT_APP_FATOORAH_URL
                  }/sale-invoice-details/${String(selectedInvoice.encryptId)}`
                : ''
            }
          /> */}
        </div>
      </div>

      {selectedInvoice?.user && renderClient()}
      {selectedInvoice?.products?.length > 0 && renderModels()}
      {renderExtraPrices()}
      {renderInovicePrices()}
    </div>
  );
});

export default SaleInvoiceDetailsComponent;
